import { workList } from "./work-list.constant";

export const workSlugs = Object.values(workList.map((item) => item.slug));